import type { AccessibleModule } from "@shared/types";

/** Attribute that marks an element as a tour anchor */
export const TOUR_ID_ATTRIBUTE = "data-tour-id";

/**
 * Tour anchor ids grouped by feature. Put the same constant on the element
 * (`data-tour-id={TOUR_IDS.batches.table}`) and in its registry step
 * (`target: tourTargetSelector(TOUR_IDS.batches.table)`) so the two can never drift.
 */
export const TOUR_IDS = {
  profile: { userNav: "user-nav" },
  orders: { table: "orders-table", showSummary: "orders-show-summary", export: "orders-export" },
  batches: {
    statusFilters: "batches-status-filters",
    search: "batches-search",
    table: "batches-table",
    summary: "batches-summary",
    summaryMetrics: "batches-summary-metrics",
    printActions: "batches-print-actions",
    export: "batches-export",
  },
  products: { searchFilters: "products-search-filters", table: "products-table", syncList: "products-sync-list" },
  contactUs: { page: "contact-us" },
  onboarding: {
    serviceTiles: "onboarding-service-tiles",
    shopifyShopDomain: "onboarding-shopify-shop-domain",
    wooCommerceFields: "onboarding-woocommerce-fields",
  },
} as const;

/** Sidebar links are rendered from a list, so their anchor id is derived from the module */
export const setSidebarNavTourId = (module: AccessibleModule): string => `sidebar-nav-${module}`;

export type ProductSyncRowStatus = "mapped" | "unmapped";

/** Bag-size rows are rendered from a list, so their anchor id is derived from the mapping state */
export const setProductSyncRowTourId = (status: ProductSyncRowStatus): string => `product-sync-row-${status}`;
